import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Top100Players from "./top100Players/top100players";
import "./ranking.scss";
import { useEffect } from "react";
import Scrollto from "../../tools/scrollTo";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useLang } from "../../../i18n/LangContext";

const Ranking = () => {
  const matches = useMediaQuery("(max-width:500px)");
  const { t } = useLang();
  useEffect(() => {}, [matches]);

  return (
    <div>
      <span style={{ position: "relative" }}>
        <Scrollto position={matches ? 329 : 200} />
      </span>
      <h2 id="RankingTitle" className="RankingTitle">
        {t("player_rankings")}
      </h2>
      <Top100Players />
    </div>
  );
};

export default Ranking;
